module.exports = "/dist/assets/images/diagonalLinesGrey.svg";